import React from "react";

const Footer = () => {
  return (
    <footer id="footer">
      <p>Copyright Smart City Technology Company Ltd. &copy;2023</p>
    </footer>
  );
};

export default Footer;
